import { FormControl } from "@angular/forms";

export interface LTETTL {
    TTL_HL_EN: boolean;
    TTL: number;
    HL: number;
};

export interface LTETTLForm {
    TTL_HL_EN: FormControl<boolean>;
    TTL: FormControl<number>;
    HL: FormControl<number>;
};